import React from 'react'
import styled from 'styled-components'

export const ProgramYule2025: React.FC = () => {
  return (
    <Root>
      <PageHeadingContainer>
        <Logo src={require('../assets/katla-logo.png')} />
        <PageTitle>Ekkert stress - bara jól!</PageTitle>
        <PageSubTitle>- Kvennakórinn Katla - </PageSubTitle>

        <PageInstructions>
          <ProgramList>
            <ProgramListItem>
              <strong>Dansaðu vindur</strong> - Peter Grönvall/Nanne Grönvall
              <ProgramListInfo>
                Íslenskur texti: Kristján Hreinsson
              </ProgramListInfo>
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Feliz navidad</strong> - José Feliciano
              <ProgramListInfo>Útsetning: Paul Langford</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Það á að gefa börnum brauð</strong> - Íslenskt þjóðlag
              <ProgramListInfo>Útsetning: Jórunn Viðar</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>In this heart</strong> - Sinéad O´Connor
              <ProgramListInfo>Útsetning: Gunnar Benediktsson</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Just for now</strong> - Imogen Heap
              <ProgramListInfo>
                Útsetning: Lilja Dögg Gunnarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Það minnir svo ótal margt á jólin</strong> - Meredith
              Wilson
              <ProgramListInfo>Íslenskur texti: Jónas Friðrik</ProgramListInfo>
              <ProgramListInfo>Útsetning: Kevin Shen</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Ekkert mál</strong> - Ragnhildur Gísladóttir
              <ProgramListInfo>Útsetning: Lilja og Hildigunnur</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>There must be an angel (playing with my heart)</strong> -
              Eurythmics
              <ProgramListInfo>
                Útsetning: Hildigunnur Einarsdóttir
              </ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>Hafðu það sem allra best um jólin</strong> - Ralph Blane
              <ProgramListInfo>
                Íslenskur texti: Ingibjörg Gunnarsdóttir
              </ProgramListInfo>
              <ProgramListInfo>Útsetning: Kevin Shen</ProgramListInfo>
            </ProgramListItem>
            <ProgramListItem>
              <strong>All I want for christmas</strong> - Mariah Carey / Walter
              Afanasieff
              <ProgramListInfo>Útsetning: Stefan Wyatt</ProgramListInfo>
            </ProgramListItem>

            <ProgramListItem>
              <strong>Santa baby</strong> - Joan Javits/Philip Springer/Tony
              Springer
              <ProgramListInfo>
                Íslenskur texti: Helga Guðmundsdóttir
              </ProgramListInfo>
            </ProgramListItem>

            <ProgramListItem>
              <strong>War is over</strong> - John Lennon/Yoko Ono
              <ProgramListInfo>
                Útsetning: Þorgrímur Þorsteinsson
              </ProgramListInfo>
            </ProgramListItem>

            <ProgramListItem>
              <strong>Klukknanna köll</strong> - Frá Úkraínu, M. Leontovich
              <ProgramListInfo>
                Útsetning: Gunnlaugur V. Snævarr
              </ProgramListInfo>
            </ProgramListItem>
          </ProgramList>
        </PageInstructions>
      </PageHeadingContainer>
    </Root>
  )
}

const Root = styled.div`
  font-family: Geometria;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: rgba(225, 173, 157, 0.8);
  padding: 2rem 4rem;
  min-height: 100vh;

  .border-bottom {
    border-bottom: 0.125rem solid rgba(128, 128, 128, 0.2);
  }

  @media screen and (max-width: 800px) {
    padding: 1.5rem;
  }
`
const PageHeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  max-width: 65rem;

  margin-top: 5rem;
  @media screen and (max-width: 800px) {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
  @media screen and (max-width: 640px) {
    margin-top: 0;
  }
`
const Logo = styled.img`
  height: 6rem;
  width: 6rem;
`
const PageTitle = styled.h1`
  font-family: Geometria-Medium;
  font-size: 4rem;

  margin-top: 1rem;

  @media screen and (max-width: 800px) {
    font-size: 3rem;
  }
`
const PageSubTitle = styled.h3`
  font-family: Geometria-Medium;
  margin-top: -2.5rem;
  margin-bottom: 2.5rem;

  @media screen and (max-width: 800px) {
    margin-top: -1.5rem;
  }
`
const PageInstructions = styled.div`
  font-size: 1.25rem;
`

const ProgramList = styled.ol`
  font-size: 1rem;
  text-align: left;
  padding-left: 0;
  margin-left: 4rem;
  margin-bottom: 5rem;

  @media screen and (max-width: 800px) {
    margin-left: 2rem;
  }
`

const ProgramListItem = styled.li`
  margin-bottom: 1rem;
  font-size: 1rem;

  & > a {
    text-decoration: none;
    font-size: 1rem;
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
`

const ProgramListInfo = styled.p`
  font-size: 0.875rem;
  // css rule for only first element of this type
  margin-top: 0.25rem;

  &:first-of-type {
    margin-bottom: 0.25rem;
  }
  /* margin-top: 0.25rem; */
`

/* #e1ad9d */
